import { autoinject, computedFrom, transient, useView } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { EntityTypeConfigurationHelper, EntityTypeConfigurationModel } from "../../../../../../models/basics/basics.models";
import { IOrderMetaPlugin } from "../../../../../../models/rightstore/rightstore.models";
import { SelectedVesselInspections } from "./selected-vessel-inspections";

@autoinject()
@transient()
@useView('views/pages/modules/orders/plugins/vessel-rightship-inspection-report/vessel-rightship-inspection-report.html')
export class VesselRightShipInspectionReport implements IOrderMetaPlugin {
    public vesselId: number;
    vesselName: string;
    selectedVesselInspections: SelectedVesselInspections;
    public vesselEntityTypes: EntityTypeConfigurationModel[];

    public canSubmit: boolean = true;

    @computedFrom("vesselId")
    public get disableSubmit(): boolean {
        return !(this.vesselId && this.vesselId != null);
    }
    viewTitle: string = "Vessel RightShip Inspection Report";
    constructor(protected i18N: I18N,
        private entityTypeConfigurationHelper: EntityTypeConfigurationHelper) {
        this.vesselEntityTypes = this.entityTypeConfigurationHelper.getConfigurationWithoutPermissions(["VesselSearch"]);
    }

    public onVesselSelected(vessel: any) {
        this.vesselId = vessel ? vessel.id : null;
        this.vesselName = vessel ? vessel.name : null;
    }

    public async isValid(): Promise<boolean> {
        const valid = this.selectedVesselInspections.inspections && this.selectedVesselInspections.inspections.length > 0;
        return valid;
    }

    public getMetaModel() {
        const selectedInspection = this.selectedVesselInspections.inspections[0].item;
        const metaModel = {
            selectedInspection: selectedInspection
        };

        return metaModel;
    }
}